export default {
  isTourbuzz: () => {
    const h = window.location.hostname;
    return h.indexOf("tourbuzz.net") !== -1 || h.indexOf("tourbuzz.info") !== -1;
  },
  isMyUrbanimmersive: () => {
    return window.location.hostname.indexOf("my.urbanimmersive.com") !== -1;
  },
  isCustomDomain: () => {
    const h = window.location.hostname;
    return (
      h.indexOf("tourbuzz.net") === -1 &&
      h.indexOf("tourbuzz.info") === -1 &&
      h.indexOf("my.urbanimmersive.com") === -1
    );
  },
  isClientPanel: () => {
    return window.location.pathname.startsWith("/panel/client");
  },
  isImmersive3dTourPanel: () => {
    return window.location.pathname.startsWith("/panel/immersive-3d-tour");
  },
};
